<div class="container">
    <ng-container *ngIf="!confirmAction">
        <div class="title_container">
            <div class="title">{{"deliveryChoice.homeDeliveryChoice.titleBis" |translate}}</div>
            <img class="quit_cross" src="assets/images/quit_cross.svg" (click)="onNoClick()">
        </div>
        <div class="date_container">
            <div class="date_bloc" *ngFor="let oneDate of data.deliveryChoiceResponse.deliveryInformation.deliveryDatesList" (click)="validateDate(oneDate)" [ngStyle]="{'background-color' : oneDate===pickedDate? '#F8F0CB': ''}">
                <div class="day_letter">{{oneDate | date:"EEEE" :'': 'fr' | titlecase}}</div>
                <div class="day_number">{{oneDate | date:"d" :'': 'fr' }}</div>
                <div class="month">{{oneDate | date:"MMMM" :'': 'fr' | titlecase }}</div>
                <div class="year">{{oneDate | date:"yyyy" :'': 'fr'}}</div>
            </div>
        </div>
        <div class="buttons_container">
            <div class="validate modify" (click)="modifyChoiceDate()" *ngIf="this.data.isModify">{{"button.modify" | translate}}</div>
            <div class="validate" *ngIf="isDatePicked" (click)="isDatePicked? saveChoices() : ''">{{"button.ok" | translate}}
            </div>
        </div>
    </ng-container >
    <ng-container class *ngIf="confirmAction && !choiceConfirmed">
        <app-validate-choice [chosenDay]="pickedDate" title="deliveryChoice.homeDeliveryChoice.choiceValidation" [email]="data.deliveryChoiceResponse.consigneeInformation.email" [validateAction]="validateChoice" [modifyAction]="modifyChoiceConfirm">
        </app-validate-choice>
    </ng-container>
    <ng-container *ngIf="choiceConfirmed">
        <app-confirm-bloc message1="confirmation_block.delivery_confirmation.message" [dialogRef]="dialogRef" [tag]="this.data.tag" tagPageName="reprogrammation_domicile_confirmation"></app-confirm-bloc>
    </ng-container>
</div>